import React from 'react';
import { AlertCircle, CheckCircle2, XCircle } from 'lucide-react';

interface NotificationProps {
  type: 'success' | 'error' | 'info';
  message: string;
  onClose?: () => void;
}

export function NotificationToast({ type, message, onClose }: NotificationProps) {
  const bgColor = {
    success: 'bg-green-100 dark:bg-green-900',
    error: 'bg-red-100 dark:bg-red-900',
    info: 'bg-blue-100 dark:bg-blue-900'
  }[type];

  const textColor = {
    success: 'text-green-800 dark:text-green-100',
    error: 'text-red-800 dark:text-red-100',
    info: 'text-blue-800 dark:text-blue-100'
  }[type];

  const Icon = {
    success: CheckCircle2,
    error: XCircle,
    info: AlertCircle
  }[type];

  React.useEffect(() => {
    if (onClose) {
      const timer = setTimeout(onClose, 5000); // Auto close after 5 seconds
      return () => clearTimeout(timer);
    }
  }, [onClose]);

  return (
    <div
      className={`fixed bottom-4 right-4 flex items-center gap-2 px-4 py-2 rounded-md shadow-lg ${bgColor} ${textColor} z-50`}
      role="alert"
    >
      <Icon className="h-5 w-5" />
      <p>{message}</p>
      {onClose && (
        <button
          onClick={onClose}
          className="ml-2 hover:opacity-80"
          aria-label="Close notification"
        >
          ×
        </button>
      )}
    </div>
  );
}